import { __assign } from "tslib";
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { mapMetaToOpenGraph, mapMetaToJsonLd, renderOpenGraph, renderJsonLd, getWebPageMeta, } from '.';
export var KesproHelmet = function (props) {
    var description = props.description ? props.description : '';
    var defaultMeta = getWebPageMeta({
        name: props.title || props.defaultTitle || 'Kespro',
        url: parseUrl(props.baseUrl, props.canonicalPath),
        description: description,
        robots: undefined,
    });
    var pageMeta = __assign({ image: props.defaultImage }, (props.pageMeta || defaultMeta));
    var titleTemplate = props.titleTemplate || '%s';
    var defaultTitle = props.defaultTitle || 'Kespro';
    return (React.createElement(Helmet, { defaultTitle: defaultTitle, titleTemplate: titleTemplate },
        React.createElement("link", { key: "canonical", rel: "canonical", href: props.baseUrl + props.canonicalPath }),
        renderMeta('description', 'description', description),
        pageMeta.robots && pageMeta.robots.map(function (content) { return renderMeta("robots-" + content, 'robots', content); }),
        renderTitle(props.title),
        renderOpenGraph(mapMetaToOpenGraph(pageMeta)),
        renderJsonLd(mapMetaToJsonLd(pageMeta)),
        props.children));
};
function parseUrl(baseUrl, path) {
    var p = path || '';
    return baseUrl.replace(/\/+$/, '') + "/" + p.replace(/^\/+/, '');
}
function renderTitle(title) {
    if (title !== undefined) {
        return React.createElement("title", null, title);
    }
    // tslint:disable-next-line:no-null-keyword
    return null;
}
function renderMeta(key, name, content) {
    if (content !== undefined) {
        return React.createElement("meta", { key: key, name: name, content: content });
    }
    // tslint:disable-next-line:no-null-keyword
    return null;
}
